
import { Question } from '../types';

// Stages in days: 1, 3, 7, 15, 30, 90
const REVIEW_INTERVALS = [1, 3, 7, 15, 30, 90];

export const calculateNextReview = (currentStage: number, isCorrect: boolean): { stage: number, nextReview: number } => {
    const now = Date.now();
    const oneDay = 24 * 60 * 60 * 1000;

    if (!isCorrect) {
        // Reset to Stage 0 (Review tomorrow) if wrong
        return {
            stage: 0,
            nextReview: now + oneDay 
        };
    } else {
        // Advance stage
        const nextStage = Math.min(currentStage + 1, REVIEW_INTERVALS.length);
        const daysToAdd = REVIEW_INTERVALS[nextStage - 1] || 1;
        
        return {
            stage: nextStage,
            nextReview: now + (daysToAdd * oneDay)
        };
    }
};

export const getReviewStatus = (q: Question): 'due' | 'future' | 'new' => {
    if (!q.nextReviewAt) return 'new';
    if (q.nextReviewAt <= Date.now()) return 'due';
    return 'future';
};

export const getDueQuestions = (questions: Question[]): Question[] => {
    // Standardize to end of current day to ensure items due later today are included
    const todayEnd = new Date();
    todayEnd.setHours(23, 59, 59, 999);
    const cutoffTimestamp = todayEnd.getTime();

    return questions.filter(q => {
        if (q.deletedAt || q.isMastered) return false;
        
        // Case 1: Has a scheduled review time and it is before end of today
        if (q.nextReviewAt) {
            return q.nextReviewAt <= cutoffTimestamp;
        }

        // Case 2: No scheduled review time (New Question)
        // In a mistake book, every new item is a mistake that needs reviewing.
        // We treat them as "Due" immediately.
        return true;
    });
};
